<div [formGroup]="groupForm()">
  <app-details-expansion-panel class="expansion-panel-spacing" [panelOpenState]="false" [title]="viewModel().displayName" [flat]="true">
    @if (viewModel().showActivateAllOption) {
      <div class="pb-3">
        <mat-slide-toggle [formControl]="groupForm().controls.hasActiveSingleLayers">
          {{ "Module.Layer.ActivateAll" | transloco }}
        </mat-slide-toggle>
      </div>
    }

    @if (!viewModel().hasFilters) {
      <div formArrayName="layerInfos">
        @for (ctrl of layerInfosArray.controls; track $index; let i = $index) {
          <div [formGroupName]="i">
            <app-layer-info
              [form]="ctrl"
              [viewModel]="viewModel().layerInfos[i]"
              [useSlideToggle]="true"
              [isLast]="i === layerInfosArray.length - 1"
            />
          </div>
        }
      </div>
    }

    @if (viewModel().hasFilters) {
      <div class="flex flex-col" formArrayName="filters">
        @for (filterCtrl of filtersArray.controls; track $index; let k = $index) {
          <div [formGroupName]="k" class="flex justify-between items-center mb-2">
            <span>{{ viewModel().filters[k].displayName }}</span>
            <mat-slide-toggle formControlName="isActivated" />
          </div>
        }
      </div>

      @if (viewModel().filteredLayerInfos.length > 0) {
        <div formArrayName="layerInfos" class="layer-container">
          @for (layerInfo of viewModel().filteredLayerInfos; track layerInfo.id; let idx = $index) {
            @let ctrl = getLayerInfoControlById(layerInfo.id);
            @if (ctrl) {
              <app-layer-info [form]="ctrl" [viewModel]="layerInfo" />
            }
          }
        </div>
      }
    }
  </app-details-expansion-panel>
</div>
